import { render, staticRenderFns } from "./CreateKeywords.vue?vue&type=template&id=57661899&scoped=true&"
import script from "./CreateKeywords.vue?vue&type=script&lang=js&"
export * from "./CreateKeywords.vue?vue&type=script&lang=js&"
import style0 from "./CreateKeywords.vue?vue&type=style&index=0&id=57661899&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57661899",
  null
  
)

export default component.exports